<p-select
  name="product"
  [appendTo]="'body'"
  [(ngModel)]="this.selected"
  [options]="this.products"
  [filter]="true"
  [placeholder]="this.placeholder | translate"
  optionLabel="name"
  size="small"
  (onChange)="this.onSelect(this.selected)"
  fluid
></p-select>
